import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MpFuncionnalErrorLabelComponent } from './mp-functionnal-error-label.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [MpFuncionnalErrorLabelComponent],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [MpFuncionnalErrorLabelComponent],
})
export class MpFuncionnalErrorLabelModule {}
